import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=41e531fa&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"
import style0 from "./Sample.vue?vue&type=style&index=0&id=41e531fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e531fa",
  null
  
)

export default component.exports